import React, {useState, useCallback, useEffect} from "react";
import { listUserProfiles } from '../graphql/queries';

// import generateDate from '../assets/functions/generateDate.js';

import { generateClient } from "aws-amplify/api";
const client = generateClient()

const Backend = (props) => {
    const [startBackend, setStartBackend] = useState(true)

    const fetchUserProfile = useCallback(async () => {
        console.log("fetching")
        try {
          const userData = await client.graphql({
            query: listUserProfiles,
            authMode: 'userPool'
          });
          if (userData.data.listUserProfiles.items.length>0) {
            props.setUserProfile(userData.data.listUserProfiles.items[0])
            // console.log('user profile set');
            // console.log(userData.data.listUserProfiles.items[0])
            //TODO check if this is accurate when there are more than one user profiles in existence
          }
          console.log(userData)
        } catch (err) {
            console.log(err)
          console.log('error fetching users');
        }
}, [props])

    useEffect(() => {
        if (startBackend) {
        fetchUserProfile()
        }
        setStartBackend(false)
      }, [props, startBackend, fetchUserProfile])


    return (
        <div className="backend">
        </div>
    )
}

export default Backend;